import type { Profile } from '../../utils/walletSnapshot';

import {
    AdminLevel,
    OrganizerLevel,
    canOrganizerManageVenues,
    resolveAdminLevel,
    resolveOrganizerLevel,
} from './accessLevels';

export interface AccessInput {
    adminRole?: string | null | undefined;
    organizerProfile?: Profile | null | undefined;
}

export interface AccessRules {
    adminLevel?: AdminLevel | undefined;
    organizerLevel?: OrganizerLevel | undefined;
    isAdmin: boolean;
    isSuperAdmin: boolean;
    isOrganizerFull: boolean;
    isOrganizerPending: boolean;
    canManageVenues: boolean;
}

const ADMIN_RANK: Record<AdminLevel, number> = {
    admin: 1,
    superadmin: 2,
};

const ORGANIZER_RANK: Record<OrganizerLevel, number> = {
    none: 0,
    pending: 1,
    full: 2,
};

export const meetsAdminLevel = (level: AdminLevel, required: AdminLevel): boolean => {
    return ADMIN_RANK[level] >= ADMIN_RANK[required];
};

export const meetsOrganizerLevel = (level: OrganizerLevel, required: OrganizerLevel): boolean => {
    return ORGANIZER_RANK[level] >= ORGANIZER_RANK[required];
};

export const buildAccessRules = ({ adminRole, organizerProfile }: AccessInput): AccessRules => {
    const adminLevel = adminRole ? resolveAdminLevel(adminRole) : undefined;
    const organizerLevel = organizerProfile ? resolveOrganizerLevel(organizerProfile) : undefined;

    const canManageVenues = organizerProfile
        ? canOrganizerManageVenues(organizerProfile, organizerLevel)
        : Boolean(adminLevel);

    return {
        adminLevel,
        organizerLevel,
        isAdmin: Boolean(adminLevel),
        isSuperAdmin: adminLevel === 'superadmin',
        isOrganizerFull: organizerLevel === 'full',
        isOrganizerPending: organizerLevel === 'pending',
        canManageVenues,
    };
};
